export default function FlashDealsTabs({
  tabs,
  value,
  onChange,
}) {
  return (
    <div
      className="flex gap-2 overflow-x-auto rounded-[1.5rem] border border-border/60 bg-white/90 p-2 shadow-lg shadow-black/5 backdrop-blur-xl [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
      role="tablist"
      aria-label="Flash deal filters"
    >
      {tabs.map((tab) => {
        const active = tab.value === value;

        return (
          <button
            key={tab.value}
            type="button"
            role="tab"
            aria-selected={active}
            onClick={() => onChange(tab.value)}
            className={`min-h-11 shrink-0 rounded-full px-5 py-2 text-xs font-black uppercase tracking-wide transition focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-offset-2 ${
              active
                ? "bg-neutral-950 text-white"
                : "bg-transparent text-muted-foreground hover:bg-neutral-100 hover:text-foreground"
            }`}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
}